import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";

import { theme } from "../../../theme/css/theme.css";
import { disabledState } from "../../../theme/disabledState";
import { transition } from "../../../utils";

export const listOptionStyle = recipe({
  base: {
    lineHeight: 1,
    gap: theme.spacings.xs,
    padding: theme.spacings.xxs,
    cursor: "pointer",
    transition: transition("background-color", "color", "border-color"),
    borderRadius: theme.borderRadiuses.xs,
    border: "1px solid transparent",
    textAlign: "left",
    overflow: "hidden",
    outlineOffset: "-2px",
    outline: "2px solid transparent",
    ":focus-visible": {
      outline: "2px solid transparent",
    },
  },
  variants: {
    active: {
      true: {
        fontWeight: "bold",
      },
    },
    activeNotMulti: {
      true: {
        // pointerEvents: "none",
      },
    },
    disabled: {
      true: {
        ...disabledState,
      },
    },
    selected: {
      true: {
        outlineColor: theme.colors.primary,
        ":focus-visible": {
          outlineColor: theme.colors.primary,
        },
      },
    },
    variant: {
      default: {
        selectors: {
          "&:hover:not([aria-disabled])": {
            backgroundColor: theme.colors.primary,
            color: theme.colors.onPrimary,
          },
        },
      },
      error: {
        selectors: {
          "&:hover:not([aria-disabled])": {
            backgroundColor: theme.colors.error,
            color: theme.colors.onError,
          },
        },
      },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const edgeContentStyle = style({
  overflow: "hidden",
});

export const checkboxStyle = style({
  pointerEvents: "none",
});
